import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import PassengerSSRInterface from '../../interfaces/client/PassengerSSR'

import store from '../../store'

const isParentUpdated = (
  passenger: ClientPassengerInterface,
  originalPassenger: ClientPassengerInterface
) =>
  passenger.firstName !== originalPassenger.firstName ||
  passenger.lastName !== originalPassenger.lastName ||
  passenger.dateOfBirth !== originalPassenger.dateOfBirth ||
  passenger.gender !== originalPassenger.gender

const isLuggageAddedOrRemoved = (
  passenger: ClientPassengerInterface,
  originalPassenger: ClientPassengerInterface
) =>
  (!passenger.luggage && originalPassenger.luggage) ||
  (passenger.luggage && !originalPassenger.luggage)

const isLuggageUpdated = (
  passenger: ClientPassengerInterface,
  originalPassenger: ClientPassengerInterface
) =>
  passenger.luggage &&
  originalPassenger.luggage &&
  passenger.luggage !== originalPassenger.luggage

const isInfantAddedOrRemoved = (
  passenger: ClientPassengerInterface,
  originalPassenger: ClientPassengerInterface
) =>
  (passenger.infant && !originalPassenger.infant) ||
  (!passenger.infant && originalPassenger.infant)

export default (passenger: ClientPassengerInterface) => {
  const state: ReduxStoreInterface = store.getState()
  const originalPassenger: ClientPassengerInterface =
    state.passengers.byId[passenger.id]

  const passengerSSRs = state.passengerSSRs.byId[passenger.id] || []

  const parentIsUpdated = isParentUpdated(passenger, originalPassenger)
  const luggageIsAddedOrRemoved = isLuggageAddedOrRemoved(
    passenger,
    originalPassenger
  )
  const luggageIsUpdated = isLuggageUpdated(passenger, originalPassenger)
  const infantIsAddedOrRemoved = isInfantAddedOrRemoved(
    passenger,
    originalPassenger
  )

  if (
    parentIsUpdated ||
    luggageIsAddedOrRemoved ||
    luggageIsUpdated ||
    infantIsAddedOrRemoved
  ) {
    return true
  }

  // Infant date was updated
  if (passenger.infant && originalPassenger.infant) {
    const passengerInfant = passenger.infant
    const originalPassengerInfant = originalPassenger.infant

    if (
      passengerInfant.firstName !== originalPassengerInfant.firstName ||
      passengerInfant.lastName !== originalPassengerInfant.lastName ||
      passengerInfant.dateOfBirth !== originalPassengerInfant.dateOfBirth ||
      passengerInfant.gender !== originalPassengerInfant.gender
    ) {
      return true
    }
  }

  // Passenger SSR was updated
  const addedOrRemovedSSRs = passengerSSRs.find(
    (passengerSSR: PassengerSSRInterface) =>
      passengerSSR.toDelete || !passengerSSR.isConfirmed
  )
  if (addedOrRemovedSSRs) {
    return true
  }

  return false
}
